import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=48ef92a2"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=48ef92a2&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48ef92a2')) {
      api.createRecord('48ef92a2', component.options)
    } else {
      api.reload('48ef92a2', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=48ef92a2", function () {
      api.rerender('48ef92a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Study/Index.vue"
export default component.exports